import React from 'react';
import CompanyDetails from './CompanyDetails';
import PasswordSection from './PasswordSection';
import SignatureSection from '../Company/SignatureSection';
import { Box, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { userSelector } from '../../../user-redux/selector';

const CompanySection = () => {
    const { user } = useSelector(userSelector); // Access user details from the Redux store
    const showSignatureSection =
        user?.usertype == 3 || user?.usertype == 13;

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2, // Space between sections
                mt: 0.5, // Top margin
            }}
        >
            {/* Company Details Section */}
            {user?.usertype != 6 && <CompanyDetails />}

            {/* Side-by-side Sections */}
            <Grid container spacing={2}>
                <Grid item xs={12} md={showSignatureSection ? 6 : 12}>
                    <PasswordSection />
                </Grid>
                {showSignatureSection && (
                    <Grid item xs={12} md={6}>
                        <SignatureSection />
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};

export default CompanySection;
